module.exports = __webpack_public_path__ + "static/img/logo.9693fb61.png";